// src/utils/stationenImport.js
//
// Zielfelder und Spaltenerkennung des Stations-Imports (pages/ImportStationen.jsx),
// als eigene Datei, damit die Erkennung gegen den echten Tabellenkopf testbar ist.

// Zielfelder der App. Reihenfolge = Anzeigereihenfolge im Mapping.
export const ZIELFELDER = [
  { key: "station_number", label: "Nummer", required: true },
  { key: "station_name", label: "Spielname", required: true },
  { key: "allow_groups", label: "Kinder erlaubt? (Ja/Nein)" },
  { key: "bereich", label: "Ort / Bereich" },
  { key: "game_description", label: "Erklärung (für Teilnehmer)" },
  { key: "rules", label: "Regeln" },
  { key: "score_logic", label: "Punktelogik" },
  { key: "materials", label: "Material" },
  { key: "supervisor_name", label: "Betreuer" },
  { key: "sponsor", label: "Sponsor (Spielpate)" },
  { key: "fun_fact", label: "Fun Fact" },
];

export const PFLICHT = ZIELFELDER.filter((f) => f.required).map((f) => f.key);

/** Spaltenkopf fuer den Heuristik-Vergleich normalisieren. */
function normHeader(h) {
  return String(h || "")
    .toLowerCase()
    .replace(/ä/g, "a").replace(/ö/g, "o").replace(/ü/g, "u").replace(/ß/g, "ss")
    .replace(/[^a-z0-9]/g, "");
}

// Erkennung je Zielfeld. Eher streng (Anfang/gleich statt "enthaelt"): die
// Tabelle hat Spalten wie "Material zugeordnet (automatisch)" neben "Material",
// "Betreuer (aus Personal, automatisch)" neben dem Betreuer, "Beschreibung
// (intern)" neben der Erklaerung fuer Teilnehmer.
const ERKENNUNG = {
  station_number: (n) => n === "nr" || n === "nummer" || n === "stationsnummer",
  station_name: (n) => n === "spiel" || n === "spielname" || n === "station" || n === "stationsname" || n === "name",
  allow_groups: (n) => n === "kinder" || n === "kinderja" || n === "fuerkinder" || n === "zielgruppe",
  bereich: (n) => n === "ort" || n === "bereich",
  game_description: (n) => n.startsWith("erklarung"),
  rules: (n) => n === "regeln" || n === "regel",
  score_logic: (n) => n === "punktelogik" || n === "wertung",
  materials: (n) => n === "material",
  supervisor_name: (n) => n.startsWith("betreuer"),
  sponsor: (n) => n.startsWith("sponsor"),
  fun_fact: (n) => n.startsWith("funfact"),
};

export function autoMap(headers) {
  const norm = headers.map((h) => ({ h, n: normHeader(h) }));
  const belegt = new Set();
  const map = {};
  for (const f of ZIELFELDER) {
    const treffer = norm.find(({ h, n }) => !belegt.has(h) && ERKENNUNG[f.key](n));
    map[f.key] = treffer ? treffer.h : "";
    if (treffer) belegt.add(treffer.h);
  }
  return map;
}
